<template>
  <Form style="line-height:32px"
        ref="form"
        :model="formdata"
        :label-width="120"
        inline>
    <FormItem :label="$t('erp.b2c.channel_account',{defaultValue:'渠道账号'})"
              style="width:90%"
              :rules="required"
              prop="channelId">
      <Select v-model="formdata.channelId"
              filterable
              clearable>
        <Option v-for="item in getNewAccountList"
                :value="item.attach.id"
                :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('erp.b2c.search_ordertype',{defaultValue:'订单类型'})"
              style="width:90%"
              :rules="required"
              prop="orderType">
      <Select v-model="formdata.orderType"
              filterable>
        <Option v-for="item in ordertypeList"
                :value="item.value"
                :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('erp.b2c.search_ordermark',{defaultValue:'订单标记'})"
              style="width:90%"
              :rules="required"
              prop="orderFlag">
      <Select v-model="formdata.orderFlag"
              filterable>
        <Option v-for="item in ordersignList"
                :value="item.value"
                :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('erp.b2c.is_ship',{defaultValue:'是否发货'})"
              prop="isShip"
              :rules="required">
      <RadioGroup v-model="formdata.isShip">
        <Radio label="1">
          <Icon type="social-yes"></Icon>
          <span>{{$t('erp.global.yes',{defaultValue:'是'})}}</span>
        </Radio>
        <Radio label="0">
          <Icon type="social-no"></Icon>
          <span>{{$t('erp.b2c.ship_no',{defaultValue:'否，只进入订单表'})}}</span>
        </Radio>
      </RadioGroup>
    </FormItem>
    <FormItem :label="$t('global.common.file_import',{defaultValue:'文件导入'})"
              style="width:90%">
      <Row>
        <Col span="8">
        <Upload ref="upload"
                accept=".xls, .xlsx"
                :before-upload="handleUpload"
                action="/api/v2/B2cOrder/orderImport">
          <Button icon="ios-cloud-upload-outline">{{$t('global.common.select_attachment',{defaultValue:'请选择文件'})}}</Button>
        </Upload>
        </Col>
        <Col span="16">
        <span v-if="file !== null">{{ file.name }}</span>
        <span v-else>{{$t('global.common.no_selectfiles',{defaultValue:'未选择任何文件'})}}</span>
        <a class="margin-left-20"
           @click="downtemp">{{$t('global.common.download_template',{defaultValue:'下载模板'})}}</a>
        </Col>
      </Row>
    </FormItem>
    <footer class="text-right">
      <Button type="primary"
              @click="submit">{{$t('global.common.import',{defaultValue:'导入'})}}</Button>
      <Button class="margin-left-10"
              @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { HttpUpload } from '@mods/service/base'

export default {
  props: ['activeids'],
  data () {
    return {
      loading: false,
      file: null,
      formdata: {
        channelId: "",
        orderType: "0",
        orderFlag: '0',
        isShip: '1',
      },
      required: [{
        required: true,
        message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
      }],
      // 订单类型
      ordertypeList: [
        { value: '0', label: this.$t("erp.b2c.ordertype_normally", { defaultValue: '正常销售' }) },
        { value: '1', label: this.$t("erp.b2c.ordertype_celebrity", { defaultValue: '展示订单' }) },
        { value: '2', label: this.$t("erp.b2c.ordertype_distribution", { defaultValue: '分销订单' }) },
        { value: '3', label: this.$t("erp.b2c.ordertype_brush", { defaultValue: '刷屏订单' }) },
      ],
      // 订单标记
      ordersignList: [
        { value: '0', label: this.$t("erp.b2c.regular_order", { defaultValue: '普通订单' }) },
        { value: '1', label: this.$t("erp.b2c.redpeople_order", { defaultValue: '红人订单' }) },
        { value: '2', label: this.$t("erp.b2c.sample_order", { defaultValue: '样品订单' }) },
        { value: '3', label: this.$t("erp.b2c.replacement_order", { defaultValue: '补发订单' }) },
      ],
    }
  },
  computed: {
    ...mapGetters('diction', ['getNewAccountList']),
  },
  methods: {
    handleUpload (file) {
      this.file = file;
      return false;
    },
    downtemp () {
      this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/B2cOrder/csvTemplate", {}, 'download')
    },
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      let valid = await this.$refs['form'].validate();
      if (!valid) return;
      this.upload();
    },
    async upload () {
      this.loading = true;
      // const { action, name } = this.$attrs;
      let action = process.env.VUE_APP_APIURL_BOSS + "/api/v2/B2cOrder/orderImport"
      const formData = new FormData();
      formData.append('excelFile', this.file);
      formData.append('channelId', this.formdata.channelId);
      formData.append('orderType', this.formdata.orderType);
      formData.append('orderFlag', this.formdata.orderFlag);
      formData.append('isShip', this.formdata.isShip);
      formData.append('contextId', global.SYSID);
      HttpUpload(action, formData).then(res => {
        this.loading = false;
        this.$Message.success(res.message);
        this.cancel()
      }, err => {
        this.loading = false;
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      })
    },
  }
}
</script>
